module.exports = __webpack_public_path__ + "static/media/loginbg.d5cc4310.jpg";